<template>
  <div
    class="has-validation tw-relative"
    :class="[
      !!floatLabel && 'tw-h-[40px]',
      loading && 'tw-opacity-60',
      disabled && 'tw-opacity-60',
      bodyClass,
    ]"
  >
    <div
      v-if="loading"
      class="tw-flex align-items-center tw-justify-center tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full"
    >
      <loading-spinner :show="true" size="sm" color="muted" />
    </div>
    <CFormLabel
      :class="['w-100', labelClass]"
      dir="rtl"
      v-if="!!label || $slots.default"
    >
      <font-awesome-icon
        v-if="iconFontAwesome"
        :icon="iconFontAwesome"
        class="me-1"
      />
      <base-icon
        v-if="baseIcon"
        :icon="baseIcon"
        class="tw-ml-3 tw-align-middle"
      />
      <span v-html="label"></span>
      <slot />
      <sup class="text-danger fs-13" v-if="required">*</sup>
    </CFormLabel>
    <input
      :id="inputId"
      :disabled="loading || disabled"
      :class="[
        !!errorMessage ? 'tw-border-red-200' : 'tw-border-static-inputBorder',
        !transparent && 'tw-h-[39px] tw-border',
        'tw-w-full tw-block tw-peer tw-rounded-[8px] tw-ring-0 focus:tw-ring-0 focus:tw-outline-none tw-px-2',
        text_error && 'is-invalid',
        !!floatLabel &&
          'tw-placeholder-transparent focus:placeholder:tw-text-blue-dark-200',
        !!!floatLabel && 'placeholder:tw-text-blue-dark-200 tw-py-2',
        class_computed,
        iconOnInput && '!tw-pr-8',
        showValue && startsWithPersian(showValue) && 'rtl !tw-text-right',
        showValue && !startsWithPersian(showValue) && 'ltr !tw-text-left',
      ]"
      :value="showValue"
      @input="updateValue"
      ref="input"
      @paste="updateValue"
      @blur="$emit('blur', e)"
      :placeholder="placeholder || label"
      autocomplete="off"
      @keyup.enter="$emit('keyupEnter', e)"
      v-bind="$attrs"
    />
    <label
      class="tw-mb-0 tw-label tw-absolute tw-transition-all tw-duration-200 peer-focus:tw-cursor-default peer-focus:tw-top-[-12px] peer-focus:tw-right-[10px] peer-focus:tw-text-tiny"
      :for="inputId"
      v-text="floatLabel"
      :class="[
        !!showValue &&
          'tw-cursor-default tw-top-[-12px] tw-right-[10px] tw-text-tiny',
        floatLabelBg ? 'peer-focus:' + floatLabelBg : 'peer-focus:tw-bg-white',
        iconOnInput ? 'tw-right-[32px]' : 'tw-right-[12px]',
        !!value
          ? 'tw-cursor-default tw-bg-white !tw-top-[-10px] !tw-right-[10px] tw-text-tiny'
          : 'tw-top-[8px] tw-cursor-text',
      ]"
    ></label>
    <base-icon
      v-if="iconOnInput"
      :icon="iconOnInput"
      size="20"
      class="tw-absolute tw-right-[6px] tw-top-[9px] tw-text-blue-dark-500"
      :class="iconOnInputClass"
    />
    <div
      class="invalid-feedback tw-text-red-300"
      v-if="text_error"
      v-text="text_error"
    ></div>
  </div>
</template>

<script>
import { mask } from '@bardoui/vmask'
import BaseIcon from '@/components/base/BaseIcon.vue'

export default {
  name: 'InputAyandeh',
  components: { BaseIcon },
  data() {
    return {
      val: null,
      debounceTimer: null,
      inputId: `input-${Math.random().toString(36).slice(2)}`,
    }
  },
  emits: [
    'update:value',
    'update:modelValue',
    'blur',
    'paste',
    'keyup',
    'stopTyping',
    'keyupEnter',
  ],
  mounted() {
    this.val = this.value
  },
  props: {
    value: {
      type: [String, Number],
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    floatLabel: {
      type: String,
      default: '',
    },
    floatLabelBg: {
      type: String,
      default: null,
    },
    iconFontAwesome: {
      type: String,
      default: '',
    },
    baseIcon: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: null,
    },
    numberFormat: {
      type: Boolean,
      default: false,
    },
    just: {
      type: String,
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    class: {
      type: String,
      default: '',
    },
    bodyClass: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    iconOnInput: {
      type: String,
      default: null,
    },
    iconOnInputClass: {
      type: String,
      default: null,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    stopTypingDelay: {
      type: Number,
      default: 800,
    },
  },
  methods: {
    updateValue(e) {
      if (e.target === undefined) return false

      var value = this.to_en(e.target.value)
      if (this.just === 'number') {
        value = value.toString().replaceAll(/[^0-9]/g, '')
      }
      if (this.mask !== '') {
        value = mask(value, this.mask)
      }

      let emit_value = this.numberFormat
        ? value.toString().replace(/\D/g, '')
        : value
      this.$emit('update:value', emit_value)
      this.$emit('update:modelValue', emit_value)

      this.$emit('keyup')
      this.$emit('paste')
      if (this.$store.state.v$ != undefined) {
        this.v$.$validate()
      }

      clearTimeout(this.debounceTimer)

      this.debounceTimer = setTimeout(() => {
        this.$emit('stopTyping', value)
      }, this.stopTypingDelay)
    },
    startsWithPersian(text = '') {
      if (text) {
        const trimmed = text.toString().trimStart()
        if (!trimmed) return false
        const firstChar = trimmed[0]
        return /[\u0600-\u06FF]/.test(firstChar)
      }
      return false
    },
  },
  computed: {
    showValue() {
      if (this.value === null || this.value === undefined) {
        return ''
      }

      let price = this.value.toString()

      return this.numberFormat
        ? price.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : this.value
    },
    class_computed() {
      return this.class
    },
    text_error() {
      if (this.errorMessage) {
        return this.errorMessage
      } else if (
        this.$store.state.v$ != undefined &&
        this.$store.state.v$.$invalid &&
        this.$attrs.name != undefined
      ) {
        var errors = this.$store.state.v$.$silentErrors.filter(
          (x) => x.$property == this.$attrs.name,
        )
        if (errors.length) {
          return errors[0].$message
        }
      }
      return false
    },
  },
}
</script>

<style scoped></style>
